import apiCall from "../components/apiCall";
import {UPDATE_POLICY_CHOICE_OPTIONS} from "./types";


const updatePolicyOptions = (roundId) => (dispatch) => {
  apiCall(roundId ? `/simulatiespel/beleidskeuzes/singleRound/${roundId}` : '/simulatiespel/beleidskeuzes')
    .then((options) => {
      dispatch({ type: UPDATE_POLICY_CHOICE_OPTIONS, payload: options });
    });
};

export default {
  updatePolicyOptions
};



// WEBPACK FOOTER //
// ./src/actions/policyChoice.js